import { styled } from '@mui/material';
import { MuiOtpInput, MuiOtpInputProps } from 'mui-one-time-password-input';

type StyledOTPInputProps = MuiOtpInputProps & {
  isValid?: boolean;
};

const StyledOTPInput = styled(MuiOtpInput)<StyledOTPInputProps>(({ theme, isValid = true }) => ({
  justifyContent: 'center',

  '& .MuiOtpInput-TextField': {
    backgroundColor: !isValid ? '#E161621A' : '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #7CAEBE',
  },

  '& .MuiInputBase-input': {
    fontSize: '24px',
    fontWeight: 500,
    color: !isValid ? theme.palette.error.main : theme.palette.primary.main,
    // height: 56,
    // width: 56,
    // padding: 0,
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

function OtpInput(props: StyledOTPInputProps) {
  return <StyledOTPInput {...props} />;
}

export default OtpInput;
